<div class="signup-background">
  <div class="logo-container">
    <img src="logo.png" alt="Logo" class="logo" />
  </div>
  @if (!codeSent) {
    <div class="signup-container">
      <div class="header">
        <div class="header-text">
          <h1>Sign up</h1>
          <p>Let’s begin a life-saving journey!</p>
        </div>
      </div>
      <div class="signup-card">
        @if (this.isLoading) {
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
        } @else {
          <form
            [formGroup]="signupForm"
            (ngSubmit)="onSubmitSendVerificationCode()"
          >
            <!-- Email Field -->
            <div class="form-group">
              <label for="email">Email*</label>
              <input
                id="email"
                type="email"
                class="form-control"
                formControlName="email"
                placeholder="Enter your email"
                [ngClass]="{
                  'is-invalid':
                    signupForm.get('email')?.invalid &&
                    signupForm.get('email')?.touched,
                }"
              />
              @if (
                signupForm.get("email")?.invalid &&
                signupForm.get("email")?.touched
              ) {
                <small class="text-danger">Valid email is required</small>
              }
            </div>

            <!-- Password Field -->
            <div class="form-group">
              <label for="password">Password*</label>
              <div class="passwordInput">
                <input
                  id="password"
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="password"
                  placeholder="Create a password"
                  autocomplete="off"
                  spellcheck="off"
                  [ngClass]="{
                    'is-invalid':
                      signupForm.get('password')?.invalid &&
                      signupForm.get('password')?.touched,
                  }"
                />
                @if (
                  signupForm.get("password")?.touched &&
                  !signupForm.get("password")?.hasError("required")
                ) {
                  <i
                    class="toggle-password-icon bi"
                    [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                    (click)="togglePasswordVisibility()"
                  ></i>
                }
              </div>

              @if (
                signupForm.get("password")?.invalid &&
                signupForm.get("password")?.touched
              ) {
                <small
                  *ngIf="
                    signupForm.get('password')?.errors?.['missingUppercase'] &&
                    signupForm.get('password')?.touched
                  "
                  class="text-danger"
                >
                  Password must contain at least one uppercase letter.
                </small>
                <small
                  *ngIf="
                    signupForm.get('password')?.errors?.['missingSymbol'] &&
                    signupForm.get('password')?.touched
                  "
                  class="text-danger"
                >
                  Password must contain at least one symbol (e.g., #$%^&*).
                </small>
                <small
                  class="text-danger"
                  *ngIf="
                    signupForm.get('password')?.hasError('minlength') &&
                    signupForm.get('password')?.touched
                  "
                >
                  Password must be at least 8 characters long.
                </small>
                <small
                  class="text-danger"
                  *ngIf="
                    signupForm.get('password')?.hasError('required') &&
                    signupForm.get('password')?.touched
                  "
                >
                  Password is required.
                </small>
              }
              <!-- <div class="forgotPasswordText forgot-link">
                  <a (click)="this.toggleForgotPassword()">Forgot password?</a>
                </div> -->
            </div>

            <div class="form-group">
              <label for="password">Confirm Password*</label>
              <div class="passwordInput">
                <input
                  id="confirmPassword"
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="confirmPassword"
                  placeholder="Confirm your password"
                  autocomplete="off"
                  spellcheck="off"
                  [ngClass]="{
                    'is-invalid':
                      signupForm.get('confirmPassword')?.touched && (signupForm.get('confirmPassword')?.invalid || signupForm.errors?.['passwordsMismatch'])
                     
                  }"
                />
                @if (signupForm.get("confirmPassword")?.touched &&
                  !signupForm.get("confirmPassword")?.hasError("required")) {
                  <i
                    class="toggle-password-icon bi"
                    [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"
                    (click)="toggleConfirmPasswordVisibility()"
                  ></i>
                }
              </div>

              @if (
                signupForm.errors?.["passwordsMismatch"] &&
                signupForm.get("confirmPassword")?.touched
              ) {
                <small class="text-danger">Passwords do not match</small>
              }
              @if (
                signupForm.get("confirmPassword")?.hasError("required") &&
                signupForm.get("confirmPassword")?.touched
              ) {
                <small class="text-danger"> Password is required. </small>
              }

              <!-- <div class="forgotPasswordText forgot-link">
                  <a (click)="this.toggleForgotPassword()">Forgot password?</a>
                </div> -->

              <div
                class="mt-2"
                *ngIf="errorMessage"
                [innerHTML]="errorMessage"
              ></div>
            </div>

            <!-- Submit Button -->
            <button
              type="submit"
              class="btn btn-primary btn-block"
              [ngClass]="{ 'no-padding': signUpPending }"
              [disabled]="signupForm.invalid || signUpPending"
            >
              @if (signUpPending) {
                <div class="mini-spinner-container">
                  <div class="mini-spinner"></div>
                </div>
              } @else {
                Sign up
              }
            </button>
          </form>
        }
      </div>
    </div>
  } @else {
    <div class="email-verify-container">
      <div class="header">
        <div class="header-text">
          <h1>Verify Email</h1>
          <p>Please enter the code recieved in your email to complete setup.</p>
        </div>
      </div>
      <div class="email-verify-card">
        <!-- Spinner -->
        <div *ngIf="isLoading" class="spinner-container">
          <div class="spinner"></div>
        </div>

        <form
          *ngIf="!isLoading"
          [formGroup]="verifyEmailForm"
          (ngSubmit)="onSubmitEmailVerification()"
          class="email-verify-form"
        >
          @if (!emailVerificationSuccessful) {
            <div class="form-group">
              <label for="code">Confirmation Code</label>
              <input
                id="code"
                type="text"
                formControlName="code"
                maxlength="6"
                placeholder="Enter 6-digit code"
                class="form-control"
                #mfaVerifyInput
                autocomplete="off"
                spellcheck="false"
              />
              <small
                *ngIf="
                  verifyEmailForm.get('mfaCode')?.invalid &&
                  verifyEmailForm.get('mfaCode')?.dirty
                "
                class="error-message"
              >
                Please enter a valid 6-digit code.
              </small>
            </div>
          } @else {
            <div class="success-message-box">
              <div class="success-icon">
                <i class="bi bi-check-circle"></i>
              </div>
              <h3>Success</h3>
              <p>
                Verification successful!<br />
                Redirecting to login in {{ countdown }}s...
              </p>
            </div>
          }

          <!-- Error Message -->
          <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>

          @if (!emailVerificationSuccessful) {
            <button
              type="submit"
              class="btn btn-primary btn-block"
              [ngClass]="{ 'no-padding': verificationPending }"
              [disabled]="verifyEmailForm.invalid || verificationPending"
            >
              @if (verificationPending) {
                <div class="mini-spinner-container">
                  <div class="mini-spinner"></div>
                </div>
              } @else {
                Verify Code
              }
            </button>
          }
        </form>
      </div>
    </div>
  }
</div>
